const baseURL = process.env.REACT_APP_API_URL; // Access API URL from .env

export class RouteApi {
  // User
  static login = `${baseURL}/login?`;
  static signUp = `${baseURL}/signup?`;
  static logout = `${baseURL}/logout?`;
  static deleteAccount = `${baseURL}/delete-account?`;
  static submitChangePassword = `${baseURL}/submit-change-password?`;
  static submitUpdateOneSignal = `${baseURL}/submit-update-one-signal?`;
  static activation = `${baseURL}/activation?`;
  static resetPassword = `${baseURL}/reset-password?`;
  static activationResetPassword = `${baseURL}/reset-password-activation?`;
  static submitResetPassword = `${baseURL}/submit-reset-password?`;
  static loginByFacebook = `${baseURL}/login-by-facebook?`;
  static loginByGmail = `${baseURL}/login-by-gmail?`;
  static submitFollowingUser = `${baseURL}/submit-following-user?`;
  static submitUnFollowingUser = `${baseURL}/submit-unfollowing-user?`;
  // static submitBlockUser = `${baseURL}/submit-block-user?`;
  static getPageUser = `${baseURL}/get-page-user?`;
  static getPageUserPublished = `${baseURL}/get-page-user-published?`;
  static getShopUser = `${baseURL}/get-user-shop?`;
  static getAccountShopDetail = `${baseURL}/get-account-shop-detail?`;
  static getAccountProfile = `${baseURL}/get-account-profile?`;
  static submitUpdateShopSetting = `${baseURL}/submit-update-shop-setting?`;
  static getProfessional = `${baseURL}/get-professional?`;
  static submitUpdateUserProfessional = `${baseURL}/submit-update-user-professional?`;
  static submitUpdateUserCurrentAddress = `${baseURL}/submit-update-user-current-address?`;
  static submitUpdateUserBirthAdress = `${baseURL}/submit-update-user-birth-address?`;
  static submitUpdateUserFacebookLink = `${baseURL}/submit-update-user-facebook-link?`;
  static submitUpdateUserYouTubeLink = `${baseURL}/submit-update-user-youtune-link?`;
  static submitUpdateUserTikTokLink = `${baseURL}/submit-update-user-tiktok-link?`;
  static submitUpdateUserMartalStatus = `${baseURL}/submit-update-user-marital-status?`;
  static submitUpdateUserTelegramLink = `${baseURL}/submit-update-user-telegram-link?`;
  static submitUpdateUserWorkplace = `${baseURL}/submit-update-user-workplace?`;
  static submitRemoveUserWorkplace = `${baseURL}/submit-remove-user-workplace?`;
  static submitUpdateUserEducation = `${baseURL}/submit-update-user-education?`;
  static submitRemoveUserEducation = `${baseURL}/submit-remove-user-education?`;
  static submitUpdateProfileInformation = `${baseURL}/submit-update-profile-information?`;
  static getPageInformation = `${baseURL}/get-page-information?`;
  static submitUpdateUserPage = `${baseURL}/submit-update-user-page?`;
  static submitUpdatePageCategory = `${baseURL}/submit-update-page-category?`;
  static submitDeleteProfileCover = `${baseURL}/submit-delete-profile-cover?`;
  static submitUpdateProfilePicture = `${baseURL}/submit-update-profile-picture?`;
  static getVisitingUser = `${baseURL}/get-visiting-user?`;
  static submitUpdateUserMapLink = `${baseURL}/submit-update-user-map-link?`;
  static getShopDashboard = `${baseURL}/get-shop-dashboard?`;
  static submitSendReviewPageInformation = `${baseURL}/submit-send-review-page-information?`;
  static submitUnpublishPageInformation = `${baseURL}/submit-unpublish-page-information?`;
  static submitDeletePageInformation = `${baseURL}/submit-delete-page-information?`;
  static submitInsertUserPage = `${baseURL}/submit-insert-user-page?`;
  static getPagePermission = `${baseURL}/get-page-permission?`;
  static getPagePermissionSearchUser = `${baseURL}/get-page-permission-search-user?`;
  static submitInsertPagePermission = `${baseURL}/submit-insert-page-permission?`;
  static submitUpdatePagePermission = `${baseURL}/submit-update-page-permission?`;
  static submitDeletePagePermission = `${baseURL}/submit-delete-page-permission?`;
  static getHomeTopTenFollwers = `${baseURL}/get-home-top-10-follwers?`;
  static getHomeGuestTop10Follwers = `${baseURL}/get-home-guest-top-10-follwers?`;
  static getHomeTopTenReachs = `${baseURL}/get-home-top-10-reachs?`;
  static getHomeGuestTop10Reachs = `${baseURL}/get-home-guest-top-10-reachs?`;

  //shop
  static submitSendReviewShopInformation = `${baseURL}/submit-send-review-shop-information?`;
  static submitUnpublishShopInformation = `${baseURL}/submit-unpublish-shop-information?`;
  static submitDeleteShopInformation = `${baseURL}/submit-delete-shop-information?`;
  static submitUpdateShopPage = `${baseURL}/submit-update-shop-page?`;
  static submitUpdateShopInformation = `${baseURL}/submit-update-shop-information?`;
  static submitDeleteShopCover = `${baseURL}/submit-delete-shop-cover?`;
  static getMusic = `${baseURL}/get-music?`;
  static getUserSound = `${baseURL}/get-user-sound?`;
  static getUserSoundLibrary = `${baseURL}/get-user-sound-library?`;
  static getUserSoundAlbum = `${baseURL}/get-user-sound-album?`;

  static submitInsertUserShop = `${baseURL}/submit-insert-user-shop?`;
  static getShopPermission = `${baseURL}/get-shop-permission?`;
  static getShopPermissionSearchUser = `${baseURL}/get-shop-permission-search-user?`;
  static submitInsertShopPermission = `${baseURL}/submit-insert-shop-permission?`;
  static submitUpdateShopPermission = `${baseURL}/submit-update-shop-permission?`;
  static submitDeleteShopPermission = `${baseURL}/submit-delete-shop-permission?`;
  static submitInsertShopInformation = `${baseURL}/submit-insert-shop-information?`;

  // settting & accounts
  static getProfileInfo = `${baseURL}/get-profile-info?`;
  static getUserSetting = `${baseURL}/get-user-setting?`;
  static submitUpdateUserSetting = `${baseURL}/submit-update-user-setting?`;
  static getUserDevice = `${baseURL}/get-user-device?`;
  static submitRemoveUserDevice = `${baseURL}/submit-remove-user-device?`;
  static disactivateAccount = `${baseURL}/disactivate-account?`;
  static getBlockUser = `${baseURL}/get-block-user?`;
  static submitBlockUser = `${baseURL}/submit-block-user?`;
  static submitDeletePost = `${baseURL}/submit-delete-post?`;
  static submitReportPost = `${baseURL}/submit-report-post?`;
  static submitRemoveBlockUser = `${baseURL}/submit-remove-block-user?`;
  static getBoringUser = `${baseURL}/get-boring-user?`;
  static submitBoringUser = `${baseURL}/submit-boring-user?`;
  static submitRemoveBoringUser = `${baseURL}/submit-remove-boring-user?`;
  static submitUpdateUserInterest = `${baseURL}/submit-update-user-interest?`;
  static getUserUser = `${baseURL}/get-user-user?`;
  static switchAccount = `${baseURL}/switch-account?`;
  static switchLogin = `${baseURL}/switch-login?`;
  static submitRunCampaign = `${baseURL}/submit-run-campaign?`;

  // user category
  static getCategory = `${baseURL}/get-category?`;

  // Store
  static getHomeMarketplaceQrMenu = `${baseURL}/get-home-marketplace-qr-menu?`;
  static getHomeMarketPlaceQrMenuMore = `${baseURL}/get-home-marketplace-qr-menu-more?`;
  static getPublicProfile = `${baseURL}/get-public-profile?`;
  static getProfile = `${baseURL}/get-profile?`;
  static getProfilePost = `${baseURL}/get-profile-post?`;
  static getViewShop = `${baseURL}/get-public-shop-profile?`;
  static getPublicProduct = `${baseURL}/get-public-shop-product?`;
  static getProfilePostContentsPageView = `${baseURL}/get-public-profile-post?`;
  static getHomeProfilePost = `${baseURL}/get-home-profile-post?`;
  static getPostWeb = `${baseURL}/get-post-web?`;
  static getHomeAccount = `${baseURL}/get-home-account?`;
  static getPostWebGuest = `${baseURL}/get-post-web-guest?`;

  // Communities
  static getFriendUser = `${baseURL}/get-friend-user?`;
  static getFollowerUser = `${baseURL}/get-follower-user?`;
  static getFollowingUser = `${baseURL}/get-following-user?`;

  // post
  static uploadData = `${baseURL}/upload-data?`;
  static submitRepost = `${baseURL}/submit-re-post?`;

  // comment
  static getComment = `${baseURL}/get-comment?`;
  static submitPostComment = `${baseURL}/submit-post-comment?`;
  static submitReactioncomment = `${baseURL}/submit-reaction-comment?`;
  static getSticker = `${baseURL}/get-stciker?`;
  // Upload Profile
  static getStorageHostCluster = `${baseURL}/get-storage-host-cluster?`;

  // FlipFlop Support Center
  static submitRequestDeleteAccount = `${baseURL}/submit-request-delete-account?`;
  static submitRequestFeedback = `${baseURL}/submit-request-feedback?`;

  //* New Feed
  static getNewFeedWeb = `${baseURL}/get-news-feed-web?`;
  // * New Feed Right Side
  static getHomeMarketPlaceSponsored = `${baseURL}/get-home-marketplace-sponsored?`;
  static getHomeMarketplaceSponsoredGuest = `${baseURL}/get-home-marketplace-sponsored-guest?`;
  static getHomeMarketPlaceJob = `${baseURL}/get-home-marketplace-job?`;
  static getHomeMarketplaceJobGuest = `${baseURL}/get-home-marketplace-job-guest?`;
  static getHomeMarketplaceLookingJob = `${baseURL}/get-home-marketplace-looking-job?`;
  static getHomeMarketplaceLookingJobGuest = `${baseURL}/get-home-marketplace-looking-job-guest?`;

  // * New Feed Right Side
  static getFriendUserBirthday = `${baseURL}/get-friend-user-birthday?`;

  // Notification
  static getNotification = `${baseURL}/get-notification?`;

  static postUserIdentityVerification = `${baseURL}/post-user-identity-verification?`;
  static submitVerifyEmailActivation = `${baseURL}/submit-verify-email-activation?`;

  static getPostReaction = `${baseURL}/get-post-reaction?`;
  static getSuggestionSearchMores = `${baseURL}/get-suggestion-search-mores?`;

  // * Friend
  static submitUninterestUser = `${baseURL}/submit-uninterest-user?`;

  // * Story
  static getNewsFeedStoryWeb = `${baseURL}/get-news-feed-story-web?`;
  static getProfileUserStoryWeb = `${baseURL}/get-profile-user-story-web?`;
  static getProfilePostUserStoryWeb = `${baseURL}/get-profile-post-user-story-web?`;
  static getNewsFeedStoryReactionWeb = `${baseURL}/get-news-feed-story-reaction-web?`;

  // * Reaction
  static submitPostReaction = `${baseURL}/submit-post-reaction?`;
  static submitViewReaction = `${baseURL}/submit-view-reaction?`;

  // Get shop product search Product & Services
  static getProductSearch = `${baseURL}/get-shop-product-search?`;
  static getSuggestionInit = `${baseURL}/get-suggestion-init?`;
  static getSuggestionSearch = `${baseURL}/get-suggestion-search?`;
  static getSuggestionResult = `${baseURL}/get-suggestion-result?`;
  static getshopproductdetail = `${baseURL}/get-shop-product-detail?`;
  static getShopProductGroup = `${baseURL}/get-shop-product-group?`;
  static submitInsertShopProductGroup = `${baseURL}/submit-insert-shop-product-group?`;
  static submitUpdateShopProductGroup = `${baseURL}/submit-update-shop-product-group?`;
  static submitDeleteShopProductGroup = `${baseURL}/submit-delete-shop-product-group?`;
  static submitDeleteShopPrinter = `${baseURL}/submit-delete-shop-printer?`;
  static submitDeleteShopProducts = `${baseURL}/submit-delete-shop-product?`;
  static submitUpdateShopProduct = `${baseURL}/submit-update-shop-product?`;
  static submitCreateShopProduct = `${baseURL}/submit-create-shop-product?`;
  static submitInsertShopPrinter = `${baseURL}/submit-insert-shop-printer?`;
  static submitInsertShopProductModifier = `${baseURL}/submit-insert-shop-product-modifier?`;
  static submitDeleteShopProductModifier = `${baseURL}/submit-delete-shop-product-modifier?`;
  static submitUndoDeleteShopProduct = `${baseURL}/submit-undo-delete-shop-product?`;

  // Product Recommended
  static getShopProductRecommended = `${baseURL}/get-shop-product-recommended?`;
  static submitUpdateShopProductRecommended = `${baseURL}/submit-update-shop-product-recommended?`;
  static submitDeleteShopProductRecommended = `${baseURL}/submit-delete-shop-product-recommended?`;
  // Alertive Prodcut
  static getShopProductAlternative = `${baseURL}/get-shop-product-alternative?`;
  static submitUpdateShopProductAlternative = `${baseURL}/submit-update-shop-product-alternative?`;
  static submitDeleteShopProductAlternative = `${baseURL}/submit-delete-shop-product-alternative?`;

  // Music Libraries
  static submitInsertUserSoundAlbum = `${baseURL}/submit-insert-user-sound-album?`;
  static submitUpdateUserSoundAlbum = `${baseURL}/submit-update-user-sound-album?`;
  static submitDeleteUserSoundAlbum = `${baseURL}/submit-delete-user-sound-album?`;
  static submitInsertMusicInformation = `${baseURL}/submit-insert-music-information?`;
  static submitUpdateMusicInformation = `${baseURL}/submit-update-music-information?`;
  static submitDeleteMusicInformation = `${baseURL}/submit-delete-music-information?`;
  static getMusicInformation = `${baseURL}/get-music-information?`;
  static submitUpdateMusicUrl = `${baseURL}/submit-update-music-url?`;
  static submitShareReviewMusic = `${baseURL}/submit-share-review-music?`;
  static submitSendReviewMusic = `${baseURL}/submit-send-review-music?`;
  static submitRemoveShareMusic = `${baseURL}/submit-remove-share-music?`;

  //Staff-----------------------------------
  static getShopDepartment = `${baseURL}/get-shop-department?`;
  static getShopEmployeeSearch = `${baseURL}/get-shop-employee-search?`;
  static submitUpdateShopEmployee = `${baseURL}/submit-update-shop-employee?`;
  static submitInsertShopEmployee = `${baseURL}/submit-insert-shop-employee?`;
  static submitDeleteShopEmployee = `${baseURL}/submit-delete-shop-employee?`;
  static getShopEmployeeDetail = `${baseURL}/get-shop-employee-detail?`;
  static getShopEmployeeManager = `${baseURL}/get-shop-employee-manager?`;
  static submitUpdateShopEmployeeManager = `${baseURL}/submit-update-shop-employee-manager?`;
  static submitDeleteShopEmployeeManager = `${baseURL}/submit-delete-shop-employee-manager?`;
  static submitUndoDeleteShopEmployee = `${baseURL}/submit-undo-delete-shop-employee?`;
  // static getShopPermissionSearchUser = `${baseURL}/get-shop-permission-search-user?`;
  ///shift
  static submitInsertShopShiftGroup = `${baseURL}/submit-insert-shop-shift-group?`;
  static submitDeleteShopShiftGroup = `${baseURL}/submit-delete-shop-shift-group?`;
  static submitUpdateShopShiftGroup = `${baseURL}/submit-update-shop-shift-group?`;
  static getShopEmployeeAll = `${baseURL}/get-shop-employee-all?`;

  // Tools
  static getTools = `${baseURL}/get-tool?`;
  static getToolSearch = `${baseURL}/get-tool-search?`;

  //accountDashboard
  static getAccountDashboard = `${baseURL}/get-account-dashboard?`;
  static getAccountDashboardFollowerByCountry = `${baseURL}/get-account-dashboard-follower-by-country?`;
  static getAccountDashboardAudienceGrowth = `${baseURL}/get-account-dashboard-audience-growth?`;
  static getAccountDashboardOverview = `${baseURL}/get-account-dashboard-overview?`;
  static getAccountDashboardAudienceGrowthByAge = `${baseURL}/get-account-dashboard-audience-growth-by-age?`;
  static getAccountDashboardTopPostChart = `${baseURL}/get-account-dashboard-top-post-chart?`;

  static submitDeleteComment = `${baseURL}/submit-delete-comment?`;
  static submitSendMessage = `${baseURL}/submit-send-message?`;

  // * Upload Post Content
  static getUserInitPost = `${baseURL}/get-user-init-post?`;
  static submitPost = `${baseURL}/submit-post?`;
  static getMusicWeb = `${baseURL}/get-music-web?`;
  static getStreamingHostCluster = `${baseURL}/get-streaming-host-cluster?`;
  static getMusicData = `${baseURL}/get-music-data?`;
  static submitUpdatePost = `${baseURL}/submit-update-post?`;

  // * URL No Main
  static submitUploadFile = "/api-mobile-flipflop/v1/submit-upload-files?";

  static getProfileView = `${baseURL}/get-profile-view?`;
  static getProfileViewPost = `${baseURL}/get-profile-view-post?`;

  //campaign
  static getCampaign = `${baseURL}/get-campaign?`;
  static getCampaignSearch = `${baseURL}/get-campaign-search?`;
  static submitActiveCampaign = `${baseURL}/submit-active-campaign?`;
  static getCampaignDetail = `${baseURL}/get-campaign-detail?`;
  static submitDeleteCampaign = `${baseURL}/submit-delete-campaign?`;

  // Live Studio
  static getHomeProfilePostLiveStudio = `${baseURL}/get-home-profile-post-live-studio?`;

  //  timesheets
  static getShopEmployeeTimesheetDepartment = `${baseURL}/get-shop-employee-timesheet-department?`;
  static getShopEmployeeTimesheetSearch = `${baseURL}/get-shop-employee-timesheet-search?`;
  static submitShopEmployeeTimesheetSetup = `${baseURL}/submit-shop-employee-timesheet-setup?`;
  static getShopEmployeeTimesheetDetail = `${baseURL}/get-shop-employee-timesheet-detail?`;
  static submitMatchingClockTime = `${baseURL}/submit-matching-clock-time?`;
  static submitSendMonthlyReport = `${baseURL}/submit-send-monthly-report?`;
  static getShopEmployeeTimesheetReport = `${baseURL}/get-shop-employee-timesheet-report?`;
  static getInitUploadShopEmployee = `${baseURL}/get-init-upload-shop-employee?`;
  static getInitUploadShopProduct = `${baseURL}/get-init-upload-shop-product?`;
  static submitShopAttendanceSetting = `${baseURL}/submit-shop-attendance-setting?`;
  static submitUpdateClockTime = `${baseURL}/submit-update-clock-time?`;
  static getShopPublicHoliday = `${baseURL}/get-shop-public-holiday?`;
  static submitShopPublicHoliday = `${baseURL}/submit-shop-public-holiday?`;

  // Qr TimeSheet
  static getShopShiftGroup = `${baseURL}/get-shop-shift-group?`;

  // ======== payroll=============
  static getShopEmployeePayrollCalculation = `${baseURL}/get-shop-employee-payroll-calculation?`;
  static getShopEmployeePayrollSearch = `${baseURL}/get-shop-employee-payroll-search?`;
  static saveDraftShopEmployeePayroll = `${baseURL}/save-draft-shop-employee-payroll?`;
  static getShopEmployeePayrollDetail = `${baseURL}/get-shop-employee-payroll-detail?`;
  static getShopEmployeePayrollDepartment = `${baseURL}/get-shop-employee-payroll-department?`;
  static submitShopPayrollSetting = `${baseURL}/submit-shop-payroll-setting?`;

  // payroll_month, payroll_year, payroll_step, shop_id, employee_id
  static getShopEmployeePayrollReport = `${baseURL}/get-shop-employee-payroll-report?`;
  //  department, payroll_month, payroll_year, payroll_step, shop_id, search_text

  // ===================Leave==================
  static getShopEmployeeLeaveDepartment = `${baseURL}/get-shop-employee-leave-department?`;
  static getShopEmployeeLeaveCalculation = `${baseURL}/get-shop-employee-leave-calculation?`;
  static getShopEmployeeLeaveSearch = `${baseURL}/get-shop-employee-leave-search?`;
  static getShopEmployeeLeaveDetail = `${baseURL}/get-shop-employee-leave-detail?`;
  static getShopEmployeeLeaveReport = `${baseURL}/get-shop-employee-leave-report?`;
  static getShopEmployeeLeaveDetailReport = `${baseURL}/get-shop-employee-leave-detail-report?`;
  static saveDraftShopEmployeeLeave = `${baseURL}/save-draft-shop-employee-leave?`;
  static saveUpdateLeaveDeduction = `${baseURL}/save-update-leave-deduction?`;
  static saveMatchingLeaveEntitlement = `${baseURL}/save-matching-leave-entitlement?`;
  // static getShopEmployeeLeaveDetail = `${baseURL}/get-shop-employee-leave-detail?`;

  // ----------------- EmployeeRequestType ----------
  static getShopEmployeeRequestType = `${baseURL}/get-shop-employee-request-type?`;
  static getShopEmployeeInitRequest = `${baseURL}/get-shop-employee-init-request?`;
  static submitShopEmployeeRequestForm = `${baseURL}/submit-shop-employee-request-form?`;
  static getShopEmployeeRequestSearch = `${baseURL}/get-shop-employee-request-search?`;
  static getShopEmployeeRequestDetail = `${baseURL}/get-shop-employee-request-detail?`;
  static getShopEmployeeRequestCommittee = `${baseURL}/get-shop-employee-request-committee?`;
  static submitShopEmployeeRequestUpdateStatus = `${baseURL}/submit-shop-employee-request-update-status?`;

  static submitUploadClockTime = `${baseURL}/submit-upload-clock-time?`;
  static getEssShopShift = `${baseURL}/get-ess-shop-shift?`;
}
